import { truncateString } from '@/utils/utils';

export class ContentSerializer {

    private static INSTANCE = new ContentSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeTranscript(payload: any) {
        let transcripts = payload.transcripts ? payload.transcripts : [];
        if (transcripts) {
            transcripts = transcripts.map((transcript: any) => {
                transcript.shortTranscript = truncateString(transcript.transcript, 35);
                return transcript;
            });
        }
        return transcripts;
    }

    public normalizeSummary(payload: any) {
        let summaries = payload.summary ? payload.summary : [];
        if (summaries) {
            summaries = summaries.map((summary: any) => {
                summary.shortSummary = summary.summaryText[0]
                    ? truncateString(summary.summaryText[0], 35)
                    : '';
                return summary;
            });
        }
        return summaries;
    }

}

export const contentSerializer = ContentSerializer.instance;
